import React from "react";
import {getModelFactory} from "../../../ts/model-factory/ModelFactory";
import {getManager} from "../../../ts/manager/Manager";
import {IonItem, IonList, IonSelectOption} from "@ionic/react";
import {
    LocateCountryDataChoice,
} from "../../../ts/data/locate/LocateCountryDataFactory";
import ApiResponseVO from "../../../ts/manager/api/ApiResonseVO";
import {
    LocateDataSortBy, LocateSearchParams,
    LocateReturnType,
    LocateViewSortBy
} from "../../../ts/data/locate/LocateDataFactory";
import ApiError from "../../../ts/manager/api/ApiError";
import AppButton from "../../element/button/AppButton";
import BasicForm from "../../component/form/BasicForm";
import {
    IFormProps,
} from "../../component/form/model/FormModel";
import InputFIE from "../../component/form/form-item-element/InputFIE";
import SelectFIE from "../../component/form/form-item-element/SelectFIE";
import ChooseTextOptionModal, {IChooseTextOptionModalProps} from "../../component/modal/ChooseTextOptionModal";
import HiddenInputFIE from "../../component/form/form-item-element/HiddenInputFIE";
import {LocatableDataChoice} from "../../../ts/data/locate/LocatableDataFactory";
import {PostType} from "../../../ts/manager/post/PostManager";
import {CountryCode} from "../../../module/osm/location/LocationType";
import {IAddressRequest, ILocationAddress} from "../../../module/osm/location/LocationInterface";

interface IProps extends IFormProps
{
    countryChoiceList:LocateCountryDataChoice[];
    postType:PostType|null;

    countryCode?:CountryCode|"";
    searchTermID?:string;
    latitude?:number;
    longitude?:number;

    sortBy?: LocateViewSortBy
    nearCountryCode?: string
    town?: string
    placeID?: number

    requireLocation?:boolean;
    returnType?:LocateReturnType

    nearChoice?:LocatableDataChoice|null
    nearPositionText?:string

    onSearchSubmit: (countryCode:string, latitude:number, longitude:number, searchTerm:string, sortBy:LocateViewSortBy, nearCountryCode:string, town:string, placeID:number) => void;
    onAnyChange?: () => void;

}

export default class LocateListForm extends BasicForm
{
    props: IProps;
    selectAddressModalProps:IChooseTextOptionModalProps|null = null;
    lastAddressRequest:IAddressRequest|null = null;
    countryCodes:string[] = [];

    countryCode:CountryCode|"";
    searchTermID:string;
    searchTerm:string;
    latitude:number;
    longitude:number;

    sortBy:LocateViewSortBy;
    nearCountryCode;
    town:string;
    placeID:number = 0;

    placeDisplayName:string = "";

    nearChoice:LocatableDataChoice|null
    nearPositionText:string
    hideSuccessMessage:boolean = true;

    constructor(props: IProps)
    {
        super(props);
        this.props = props;

        this.countryCode = props.countryCode ?? "";
        this.searchTermID = props.searchTermID ?? "";
        this.searchTerm = this.searchTermID !== "search_all" ? decodeURIComponent(this.searchTermID) : "";

        this.nearChoice = props.nearChoice ?? null;
        this.nearPositionText = this.props.nearPositionText ?? "Near "+(this.props.nearChoice?.name ?? "");

        this.sortBy = props.sortBy ?? "name";
        const usePositionLngLat = this.sortBy === "near_position" ? (this.nearChoice?.lngLat ?? null) : null;

        this.latitude = usePositionLngLat ? usePositionLngLat.lat : (props.latitude ?? 0);
        this.longitude = usePositionLngLat ? usePositionLngLat.lng : (props.longitude ?? 0);


        if(this.sortBy !== "near_location"){
            this.nearCountryCode = "";
            this.town = "";
            this.placeID = 0;
        } else {
            this.nearCountryCode = (props.nearCountryCode ?? "");
            this.town = (props.town ?? "");
            this.placeID = props.placeID ?? 0;
        }
        for(let choice of props.countryChoiceList){
            this.countryCodes.push(choice.id)
        }

    }

    bindFunctions(): void
    {
        super.bindFunctions()

        this.onSortByChange = this.onSortByChange.bind(this);
        this.onAnyChange = this.onAnyChange.bind(this);
    }


    initVariables()
    {
        super.initVariables();
    }

    async initModels(): Promise<void>
    {
        return this.requireCurrentPlace();
    }

    async requireCurrentPlace(): Promise<void>
    {
        if(this.props.sortBy !== "near_location" || !this.props.nearCountryCode || !this.props.town){
            return;
        }
        const request:IAddressRequest = {
            country: this.props.nearCountryCode,
            city: this.props.town
        }

        return getManager().location.getAddress(request).then((itemAddresses:ILocationAddress[]) => {
            let address:ILocationAddress|null = itemAddresses.length === 1 ? itemAddresses[0] : null;
            if(!address && this.placeID){
                for(let itemAddress of itemAddresses){
                    if(itemAddress.id === this.placeID){
                        address = itemAddress;
                        break;
                    }
                }
            }
            if(!address){
                return
            }
            this.lastAddressRequest = request;
            this.placeDisplayName = address.displayName;
        });
    }

    async handleSubmitItems(formItemIDs: string[]|null): Promise<ApiResponseVO>
    {
        const sortByItem = this.stringItem("sort_by");
        const searchTermItem = this.stringItem("search_term");
        const countryCodeItem = this.stringItem("country_code");
        const nearCountryCodeItem = this.stringItem("near_country_code");
        const townItem = this.stringItem("town");
        const latitudeItem = this.floatItem("latitude");
        const longitudeItem = this.floatItem("longitude");

        this.searchTerm = searchTermItem.getCastValue();

        this.countryCode = countryCodeItem.getCastValue() as CountryCode|"";
        this.searchTermID = this.searchTerm ? encodeURIComponent(this.searchTerm) : "search_all";
        this.latitude = latitudeItem.getCastValue();
        this.longitude = longitudeItem.getCastValue();

        this.sortBy = (sortByItem.value as LocateViewSortBy) ?? "name";

        if(this.sortBy !== "near_location"){
            this.nearCountryCode = "";
            this.town = "";
            this.placeID = 0;
        } else {
            this.nearCountryCode = nearCountryCodeItem.getCastValue();
            this.town = townItem.getCastValue();
        }

        const sortDataBy:LocateDataSortBy = this.sortBy  === "name" ? "name" : "distance";

        const searchParams:LocateSearchParams = new LocateSearchParams();
        searchParams.postType = this.props.postType ?? "organisation";
        searchParams.sortBy = sortDataBy;
        searchParams.countryCode = this.countryCode;
        searchParams.latitude = this.latitude;
        searchParams.longitude = this.longitude;
        searchParams.requireLocation = !!this.props.requireLocation;

        const locatePageModel = getModelFactory().locatePageListData.getLocatePageListDataModel(searchParams);
        const responseVO = new ApiResponseVO();

        return await locatePageModel.requirePopulated().then(() => {
            if(!locatePageModel.actualPageCount || !this.props.returnType){
                return responseVO;
            }
            const firstLocateModel = locatePageModel.getChildModel(1, this.props.returnType)!;
            return firstLocateModel.requirePopulated().then(() => {
                return responseVO;
            }).catch((error:ApiError) => {
                responseVO.apiError = error;
                return responseVO;
            });
        }).catch((error:ApiError) => {
            responseVO.apiError = error;
            return responseVO;
        });
    }

    handleSubmitComplete()
    {
        const searchTerm = this.searchTermID !== "search_all" ? decodeURIComponent(this.searchTermID) : "";
        this.props.onSearchSubmit(this.countryCode, this.latitude, this.longitude, searchTerm, this.sortBy, this.nearCountryCode, this.town, this.placeID);
    }

    onSortByChange(_:string): void
    {
        const sortByItem = this.stringItem("sort_by");
        const nearCountryCodeItem = this.stringItem("near_country_code");
        const countryCodeItem = this.stringItem("country_code");
        const townItem = this.stringItem("town");
        const latitudeItem = this.floatItem("latitude");
        const longitudeItem = this.floatItem("longitude");

        const value = sortByItem.getCastValue() as LocateViewSortBy;
        const previousValue = (sortByItem.previousValue ?? "") as LocateViewSortBy;
        if(value === "near_location"){
            nearCountryCodeItem.setValue(countryCodeItem.getCastValue());
        } else if(previousValue === "near_location"){
            countryCodeItem.setValue(this.countryCodes.includes(nearCountryCodeItem.getCastValue()) ? nearCountryCodeItem.getCastValue() : "");
        }
        this.lastAddressRequest = null;
        latitudeItem.setValue(0);
        longitudeItem.setValue(0);
        townItem.setValue("");
        this.placeID = 0;
        this.placeDisplayName = "";
        this.refreshState();
        if(value === "near_me")
        {
            this.setLoading(true);
            getManager().location.requireUserLocation(true, true).then(() => {
                const userPosition = getManager().location.getLastKnowLngLat()
                if(userPosition){
                    latitudeItem.setValue(userPosition.lat);
                    longitudeItem.setValue(userPosition.lng);
                } else {
                    sortByItem.errorText = getManager().location.getPermissionErrorMessage() ?? "ERROR";
                }
                this.setLoading(false);
                this.refreshState()
            })
        } else if(value === "near_position")
        {
            latitudeItem.setValue(this.nearChoice?.lngLat?.lat ?? 0);
            longitudeItem.setValue(this.nearChoice?.lngLat?.lng ?? 0);
        }
        this.onAnyChange();
    }

    onAnyChange(): void
    {
        if(this.props.onAnyChange){
            this.props.onAnyChange();
        }
    }


    isSubmitDisabled(): boolean
    {
        if(super.isSubmitDisabled()){
            return true;
        }
        const sortByItem = this.stringItem("sort_by");

        const sortBy = sortByItem.getCastValue() as LocateViewSortBy
        if(sortBy === "near_me"){
            const latitudeItem = this.floatItem("latitude");
            const longitudeItem = this.floatItem("longitude");
            return !latitudeItem.getCastValue() && !longitudeItem.getCastValue();
        }
        return false;
    }

    searchForLocation = () => {

        console.log("searchForLocation")

        this.prepareFormSubmit();
        if(this.invalid)
        {
            return false;
        }
        const nearCountryCodeItem = this.stringItem("near_country_code");
        const townItem = this.stringItem("town");
        const countryCode = nearCountryCodeItem.getCastValue();
        const town = townItem.getCastValue();
        if(this.lastAddressRequest && this.lastAddressRequest.country === countryCode && this.lastAddressRequest.city === town){
            this.renderAndSubmit();
            return;
        }
        const latitudeItem = this.floatItem("latitude");
        const longitudeItem = this.floatItem("longitude");
        this.lastAddressRequest = null;
        latitudeItem.setValue(0);
        longitudeItem.setValue(0);
        this.placeID = 0;
        this.placeDisplayName = "";
        this.refreshState();


        const request:IAddressRequest = {
            country: countryCode,
            city: town
        }

        const onAddressSelected = (address:ILocationAddress) => {
            this.lastAddressRequest = request;
            latitudeItem.setValue(address.lngLat.lat);
            longitudeItem.setValue(address.lngLat.lng);
            this.placeID = address.id;
            this.placeDisplayName = address.displayName;
            this.renderAndSubmit();
        }

        getManager().location.getAddress(request).then((itemAddresses:ILocationAddress[]) => {
            if(!itemAddresses.length){
                townItem.errorText = "Town could not be located";
                this.onProcessFormHalt();
            } else if(itemAddresses.length === 1){
                onAddressSelected(itemAddresses[0]);
            } else {
                const componentVersion = (this.selectAddressModalProps?.componentVersion ?? 0) + 1;
                const textOptions = [];
                for(let i= 0; i< itemAddresses.length; i ++)
                {
                    textOptions.push(itemAddresses[i].displayName);
                }
                this.selectAddressModalProps = {
                    routeProps: this.props.routeProps,
                    modalTitle: "Choose a location",
                    textOptions: textOptions,
                    componentVersion: componentVersion,
                    onModalHidden: (didSubmit:boolean, returnValue:any) => {
                        if(didSubmit){
                            const index = parseInt(returnValue);
                            onAddressSelected(itemAddresses[index]);
                        } else {
                            townItem.errorText = "No location selected";
                            this.onProcessFormHalt();
                        }
                    }
                }
                this.refreshState();
            }

        }).catch((apiError:ApiError) => {
            townItem.errorText = apiError.message;
            this.onProcessFormHalt();
        });
    }

    clearPlace()
    {
        this.placeDisplayName = "";
        this.lastAddressRequest = null;
        this.refreshState()
    }

    renderComponent()
    {

        const sortByItem = this.hasFormItem("sort_by") ? this.stringItem("sort_by") : null;
        const sortBy = (sortByItem?.getCastValue() as LocateViewSortBy) ?? this.sortBy;
        const sortByNearLocation = sortBy === 'near_location';
        const sortByNearPosition = sortBy === 'near_position';


        return <>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <form
                            onSubmit={this.handleFormSubmit}
                            className={"custom-form "+(this.isDisabled() ? "content-disabled" : "")}
                        >

                            {this.formAlerts()}
                            {this.requiredFieldsMessage()}
                            <IonList>

                                <IonItem>
                                    <SelectFIE
                                        form={this}
                                        formItemProps={{
                                            pointer: "sort_by",
                                            name: "Sort By",
                                            value: this.sortBy,
                                            required: true,
                                            errorMessages: {
                                                required: "Please select a sort method"
                                            }
                                        }}
                                        onItemChange={this.onSortByChange}
                                    >
                                        <IonSelectOption
                                            value="name"
                                        >
                                            Name
                                        </IonSelectOption>
                                        <IonSelectOption
                                            value="near_me"
                                        >
                                            Near me
                                        </IonSelectOption>
                                        {!!this.nearChoice?.lngLat && <>

                                            <IonSelectOption
                                                value="near_position"
                                            >
                                                {this.nearPositionText}
                                            </IonSelectOption>
                                        </>}
                                        <IonSelectOption
                                            value="near_location"
                                        >
                                            Near Location
                                        </IonSelectOption>
                                    </SelectFIE>
                                </IonItem>
                                {!sortByNearLocation && !sortByNearPosition &&
                                    <IonItem>
                                        <SelectFIE
                                            form={this}
                                            formItemProps={{
                                                pointer: "country_code",
                                                name: "Country",
                                                value: this.countryCode,
                                                required: sortByNearLocation
                                            }}
                                            onItemChange={this.onAnyChange}
                                        >
                                            <IonSelectOption
                                                value=""
                                            >
                                                Any
                                            </IonSelectOption>
                                            {this.props.countryChoiceList.map((choice) =>
                                            {
                                                return <IonSelectOption
                                                    key={choice.id}
                                                    value={choice.id}
                                                >
                                                    {choice.name} ({choice.count})
                                                </IonSelectOption>
                                            })}
                                        </SelectFIE>
                                    </IonItem>
                                }
                                {sortByNearLocation &&
                                    <>
                                        <IonItem>
                                            <SelectFIE
                                                form={this}
                                                formItemProps={{
                                                    pointer: "near_country_code",
                                                    name: "Country",
                                                    value: this.nearCountryCode,
                                                    required: true,
                                                    doNotSubmit: true,
                                                    errorMessages: {
                                                        required: "Please select a county"
                                                    }
                                                }}
                                                onItemChange={this.onAnyChange}
                                            >
                                            </SelectFIE>
                                        </IonItem>
                                        <IonItem>
                                            <InputFIE
                                                form={this}
                                                onItemChange={this.onAnyChange}
                                                formItemProps={{
                                                    pointer: "town",
                                                    name: "Town",
                                                    value: this.town,
                                                    required: true,
                                                    doNotSubmit: true,
                                                    errorMessages: {
                                                        required: "Please select a town"
                                                    }
                                                }}
                                            />
                                        </IonItem>
                                    </>
                                }
                                <IonItem>
                                    <InputFIE
                                        form={this}
                                        onItemChange={this.onAnyChange}
                                        formItemProps={{
                                            pointer: "search_term",
                                            name: "Key words",
                                            value: this.searchTerm,
                                        }}
                                    />
                                </IonItem>
                                <HiddenInputFIE
                                    form={this}
                                    formItemProps={{
                                        pointer: "latitude",
                                        name: "Latitude",
                                        type: "float",
                                        value: this.latitude
                                    }}
                                />
                                <HiddenInputFIE
                                    form={this}
                                    formItemProps={{
                                        pointer: "longitude",
                                        name: "Longitude",
                                        type: "float",
                                        value: this.longitude
                                    }}
                                />
                            </IonList>
                            {sortByNearLocation && this.placeDisplayName &&
                                <>
                                    <div className="clearfix w-100">
                                        <div className="form-group">
                                            <p className="small place-display-name mb-0">
                                                Searching for: {this.placeDisplayName}
                                            </p>
                                            <p className="small">
                                                <AppButton
                                                    onClick={() => this.clearPlace()}
                                                    className="anchor"
                                                    nonButton={true}
                                                >
                                                    Clear Address
                                                </AppButton>
                                            </p>
                                        </div>
                                    </div>
                                </>
                            }

                            {this.endFormAlerts()}
                            <div className="clearfix">
                                <div className="form-group float-start mt-4">
                                    <AppButton
                                        type={!sortByNearLocation ? "submit" : "button"}
                                        onClick={!sortByNearLocation ? undefined : () => this.searchForLocation()}
                                        loading={this.loading}
                                        className="btn btn-block btn-primary"
                                        disabled={this.isSubmitDisabled()}
                                    >
                                        Search
                                    </AppButton>
                                </div>
                            </div>

                        </form>

                        {this.selectAddressModalProps && <>
                            <ChooseTextOptionModal
                                {...this.selectAddressModalProps}
                                key={(this.selectAddressModalProps.componentVersion ?? 0).toString()}
                            />
                        </>}
                    </div>
                </div>
            </div>
        </>;
    }
}